import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';

// Proto: groups.Params.
export default class AutogroupParams extends Fragment {
  declare [Type]: 'autogroup-params';

  @attr('string', { defaultValue: '' })
  declare team: string;

  @attr('string', { defaultValue: '' })
  declare threshold: string;

  @attr('string', { defaultValue: '' })
  declare jurisdiction: string;

  @attr('string', { defaultValue: '' })
  declare rangeStart: string;

  @attr('string', { defaultValue: '' })
  declare rangeEnd: string;

  @attr('string', { defaultValue: '' })
  declare type: string;

  @attr('string', { defaultValue: '' })
  declare field: string;

  @attr('string', { defaultValue: '' })
  declare value: string;

  @array('string')
  declare values: StatefulArray<string>;
}
